export default __webpack_public_path__ + "static/media/cbcSala3.52311feb.jpg";